<template>
  <section class="section-xl">
    <div class="dg-container">
      <div class="row row-grid align-items-center">
        <h1 class="hp-title2" style="text-align: center">The Way to InsuranceDAO</h1>
      </div>
      <div class="row row-grid align-items-center">
        <h1 class="hp-desc ta-c" style="padding: 0 10%">
          The Bazaar Protection Market is fully governed by DEGIS token holders,
        </h1>
        <h1 class="hp-desc ta-c" style="padding: 0 10%">
          with the freedom to buy, sell, and design their own products.
        </h1>
        <h1 class="hp-desc ta-c" style="padding: 0 10%">
          Available in Version 2.
        </h1>
      </div>
      <div class="row">
        <div class="col-md-12">
          <img src="img/homepage/img.png" class="img-fluid floating"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "bazaar",
};
</script>

<style scoped>

</style>
